import React from 'react';
import PropTypes from 'prop-types';
import "./sass/progressBarValue.css";

export const ProgressBarValue = ({ id, key, porcentaje, className, componentValue, side }) => {
    
    const sideValue = (side === "left" || side === "right") ? side : "left";
    const classValue = className ? 
    "processBarValue " + className : 
    "processBarValue";

    return (
        <div id={id} key={key} className={classValue}>
            <div className={"progressBar " + sideValue} style={{ width: `${porcentaje}%` }}>&nbsp;</div>
            <span className="valuePercentage">{componentValue ? componentValue : porcentaje + '%'}</span>
        </div>
    );

};

ProgressBarValue.propTypes = {
    id: PropTypes.string,
    key : PropTypes.string,
    porcentaje : PropTypes.number.isRequired,
    className : PropTypes.string,
    componentValue : PropTypes.any,
    side : PropTypes.oneOf(["left", "right"])
};